export function getAuthToken() {
  return JSON.parse(window.localStorage.getItem('access_token'));
}

export function setAuthToken(token) {
  window.localStorage.setItem('access_token', JSON.stringify(token));
}

export function getRefreshToken() {
  return window.localStorage.getItem('refresh_token');
}

export function setRefreshToken(token) {
  window.localStorage.setItem('refresh_token', JSON.stringify(token));
}

export function removeAuthToken() {
  window.localStorage.clear();
  return true;
}

export function getUsername() {
  return JSON.parse(window.localStorage.getItem('username'));
}

export function setUsername(username) {
  window.localStorage.setItem('username', JSON.stringify(username));
}

export function setUserRole(role) {
  window.localStorage.setItem('role', role);
}

export function getUserRole() {
  return window.localStorage.getItem('role');
}

/**
 *
 * @returns {boolean}
 */
export function hasAuthToken() {
  if (localStorage.getItem('access_token')) {
    return true;
  }
  return false;
}

export function getRequestHeadersAsLogged() {
  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${getAuthToken()}`,
    'X-Refresh-Tkn': getRefreshToken() || null,
  };
}

export function getPlainRequestHeadersAsLogged() {
  return {
    'Authorization': `Bearer ${getAuthToken()}`,
    'X-Refresh-Tkn': getRefreshToken() || null,
  };
}

export function responseHandler(response) {
  if (response.status === 503){
    window.location = '/login';
    return;
  }

  const currentAccessToken = getAuthToken();
  const currentRefreshToken = getRefreshToken();
  const responseAccessToken = response.headers.get('X-Access-Tkn');
  const responseRefreshToken = response.headers.get('X-Refresh-Tkn');

  if (currentAccessToken !== responseAccessToken && responseAccessToken) {
    setAuthToken(responseAccessToken);
  }

  if (currentRefreshToken !== responseRefreshToken) {
    setRefreshToken(responseRefreshToken);
  }

  return response.json();
}
